import { ChartType } from "../../models/charts/chart-type.enum"
import { defaultChartOptions, generateCustomSeriesOptions } from "./charts-options.value"
import { numberFormatters } from "../../formatters";

export const ChartTypeOptionsMap = new Map([
  [ChartType.BTCDominance, generateCustomSeriesOptions(numberFormatters.percent, 0.2, 0.4)],
  [ChartType.TVLPerBlockChain, defaultChartOptions],
  [ChartType.TVLPerProtocols, defaultChartOptions],
  [ChartType.Top5CMC, defaultChartOptions],
  [ChartType.Total_Volume, defaultChartOptions],
  [ChartType.USDStablecoinMarketCap, defaultChartOptions],
  [ChartType.Spot_ETF_BTC_AUM_USD, defaultChartOptions],
  [ChartType.Spot_ETF_ETH_AUM_USD, defaultChartOptions],
  [ChartType.Spot_ETF_BTC_AUM_Native, generateCustomSeriesOptions(numberFormatters.bitcoinPrice, 0.2, 0)],
  [ChartType.Spot_ETF_ETH_AUM_Native, generateCustomSeriesOptions(numberFormatters.ethereumPrice, 0.2, 0)],
  [ChartType.Spot_ETF_BTC_Flows_USD, generateCustomSeriesOptions(numberFormatters.flowPrice, 0.1, 0.1)],
  [ChartType.Spot_ETF_ETH_Flows_USD, generateCustomSeriesOptions(numberFormatters.flowPrice, 0.1, 0.1)],
  [ChartType.Spot_ETF_BTC_MarketShare, generateCustomSeriesOptions(numberFormatters.percent, 0.02, 0)],
  [ChartType.Spot_ETF_ETH_MarketShare, generateCustomSeriesOptions(numberFormatters.percent, 0.02, 0)],
  [ChartType.Spot_ETF_BTC_Total_AUM_Native, generateCustomSeriesOptions(numberFormatters.bitcoinPrice, 0.01, 0.1)],
  [ChartType.Spot_ETF_ETH_Total_AUM_Native, generateCustomSeriesOptions(numberFormatters.ethereumPrice, 0.1, 0.1)],
  [ChartType.Spot_ETF_BTC_Total_AUM_USD, generateCustomSeriesOptions(numberFormatters.largeNumber, 0.1, 0.1)],
  [ChartType.Spot_ETF_ETH_Total_AUM_USD, generateCustomSeriesOptions(numberFormatters.largeNumber, 0.1, 0.1)]
])
